module.exports = __webpack_public_path__ + "6f26ddd1bf59740c536d2274bb834a05.png";